export const downloadFile = (file: string, fileName: string, mimeType: string) => {
    const a = document.createElement('a');
    const newdata = 'data:' + mimeType + ';base64,' + encodeURIComponent(file);

    //build download link:
    a.href = newdata;
    a.download = fileName;

    a.click();
    a.remove();
};